<template>
  <div id="filter-modal" class="mt-4">
    <filter-field
      :info.sync="filterParams.group_id"
      :items="groupOptions"
      :label="groupLabel"
    />
    <filter-field
      :info.sync="filterParams.ad_schedule"
      :items="filterOptions.ad_schedules"
      label="Ad Schedule"
      v-if="_client.client_name !== 'shark'"
    />
    <filter-field
      :info.sync="filterParams.version"
      :items="filterOptions.versions"
      label="Version"
    />
    <filter-field
      :info.sync="filterParams.network_status"
      :items="filterOptions.network_status"
      label="Network Status"
      v-if="_client.client_name === 'shark'"
    />
    <filter-field
      :info.sync="filterParams.session_status"
      :items="filterOptions.session_status"
      label="Status"
      v-if="_client.client_name !== 'shark'"
    />
    <filter-field
      :info.sync="filterParams.trip_type"
      :items="filterOptions.trip_type"
      :label="tripTypeLabel"
      v-if="_client.client_name !== 'shark'"
    />
    <filter-field
      :info.sync="filterParams.launch_mode"
      :items="filterOptions.launch_mode"
      :label="tripTypeLabel"
      v-if="_client.client_name === 'shark'"
    />
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import FilterField from '@/components/filter/FilterField';
import FilterParams from '@/mixins/FilterParams';

export default {
  mixins: [FilterParams],
  components: {
    FilterField,
  },
  methods: {
    ...mapMutations({
      _setFilterOptions: 'filters/setScreensFilterOptions',
    }),
  },
  computed: {
    ...mapGetters({
      _filterOptions: 'filters/getScreensFilterOptions',
      _areas: 'areas/getAreas',
      _currentClient: 'account/getCurrentClient',
      _networkHealthFilter: 'filters/getNetworkHealthFilter'
    }),
    filterOptions: {
      get() {
        return this._filterOptions;
      },
      set() {
        this._setFilterOptions();
      },
    },
    networkHealthFilter() {
      return this._networkHealthFilter;
    },
    tripTypeLabel() {
      switch (this._client.client_name) {
        case 'bazzbi':
          return 'QR Code/Digital Key';
        case 'shark':
          return 'Launch Mode';
        case 'avis':
          return 'Trip Type';
        default:
          return 'trip type';
      }
    },
    groupLabel() {
      if (this._client.client_name !== 'shark') {
        return 'Group Name';
      }
      return 'Course Name';
    },
    groupOptions() {
      this.filterOptions.groups.map(group => {
        group.text = group.text
          .toLowerCase()
          .split(' ')
          .map(s => s.charAt(0).toUpperCase() + s.substring(1))
          .join(' ');
      });
      return this.filterOptions.groups;
    }
  }
};
</script>
